@if (invoiceClientData?.id && companyDetails?.id) {
  <ng-template [ngTemplateOutlet]="invoiceOptionsTemplate"></ng-template>
  <div class="border rounded doc-width p-1 p-lg-4 bg-white text-dark">
    <div class="p-1 p-lg-3" id="print-invoice">
      <div class="row row-cols-2 w-100 overflow-x-auto bg-white text-dark">
        <div class="d-flex">
          <!--company logo-->
          @if (companyDetails?.logo_url && !companyDetails?.hideLogo) {
            <div>
              <img src="{{ companyDetails?.logo_url }}" alt="Logo" />
            </div>
          } @else {
            <div class="h3">{{ companyDetails?.name }}</div>
          }
        </div>
        <div class="text-end small">
          <!--company info-->
          <div>{{ companyDetails?.name }}</div>
          @if (companyDetails?.abn) {
            <div>ABN {{ companyDetails?.abn }}</div>
          }

          <div>
            {{ companyDetails?.address?.report_address?.address }}
          </div>
          <div class="mb-2">
            {{ companyDetails?.address?.report_address?.city }}
          </div>
          @if (companyDetails?.phone) {
            <div class="d-flex gap-1 align-items-center justify-content-end">
              <i class="fa-solid fa-phone"></i>
              {{ companyDetails?.phone }}
            </div>
          }
          <div class="d-flex gap-1 align-items-center justify-content-end">
            <i class="fa-solid fa-envelope"></i> {{ companyDetails?.email }}
          </div>
        </div>
      </div>
      <div class="row row-cols-3 pt-3">
        <div class="col-12">
          <div class="fs-5 text-center mb-3 bg-white text-dark">
            Tax Invoice
          </div>
        </div>
        <div class="col">
          <dl>
            <dt>Bill To</dt>
            <dd>
              <div class="fw-semibold">
                {{ invoiceClientData?.company_name }}
              </div>
              @if (invoiceClientData?.custom_address) {
                <div class="small gt-multi-line">
                  {{ invoiceClientData?.custom_address }}
                </div>
              }
              @if (invoiceClientData?.report_address) {
                <div class="small">
                  {{ invoiceClientData?.report_address?.address }}
                </div>
                <div class="small">
                  {{ invoiceClientData?.report_address?.city }}
                </div>
              }
            </dd>
          </dl>
        </div>
        <div class="col">
          <dl class="text-center">
            <dt>Invoice No.</dt>
            <dd>
              {{ invoiceNum }}
            </dd>
          </dl>
        </div>
        <div class="col text-end">
          <dl>
            <dt>Invoice Date</dt>
            <dd>{{ invoiceDate | date: "dd MMM yyyy" }}</dd>
          </dl>
        </div>
        <div class="table-responsive py-2 col-12">
          <table class="table table-sm w-100 border-top table-white">
            <tbody>
              <tr>
                <td class="text-start">
                  <span class="text-secondary me-2"> Sub-Total </span>
                  <span class="fw-semibold">
                    {{ regionCurrencySymbol
                    }}{{ getTotalInvoiceAmount("sale") | number: "1.2-2" }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="text-secondary me-2"> GST </span>
                  <span class="fw-semibold">
                    {{ regionCurrencySymbol
                    }}{{ getTotalInvoiceAmount("tax") | number: "1.2-2" }}
                  </span>
                </td>
                <td>
                  <div
                    class="gap-3 d-flex align-items-center justify-content-end"
                  >
                    <span class="text-secondary"> Total </span>
                    <span class="fw-semibold fs-4">
                      {{ regionCurrencySymbol
                      }}{{
                        getTotalInvoiceAmount("total") | number: "1.2-2"
                      }}</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive pt-3 col-12">
          <table class="table table-sm w-100 table-white">
            <thead class="thead-white">
              <!--to override dark theme theader-->
              <th><dt class="bg-white text-secondary fw-semibold">Item</dt></th>
              <th>
                <dt class="bg-white text-secondary fw-semibold">Description</dt>
              </th>
              <th class="text-end">
                <dt class="bg-white text-secondary fw-semibold">Excl. GST</dt>
              </th>
              <th class="text-end">
                <dt class="bg-white text-secondary fw-semibold">Incl. GST</dt>
              </th>
            </thead>
            <tbody>
              @for (job of selectedEvents; track job; let i = $index) {
                <tr class="avoid-page-break">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td>
                    <div>
                      {{ job?.site?.company_name }}
                      <span
                        class="float-end small px-1 border rounded bg-white"
                      >
                        <span class="text-secondary"> Docket #</span>
                        <span class="fw-semibold">
                          {{ job?.job_key }}
                          @if (job?.ext_job_id) {
                            <span>[{{ job?.ext_job_id }}]</span>
                          }
                        </span>
                      </span>
                    </div>
                    <div class="small">
                      {{ job?.site?.address }}
                    </div>
                    @if (
                      onsiteDurationDict?.[job?.id] &&
                      onsiteDurationDict?.[job?.id] > 0
                    ) {
                      <div>
                        <span class="text-secondary small"> Time Onsite </span>
                        <span>
                          {{ onsiteDurationDict?.[job?.id] }}
                          <span class="text-secondary small">minutes</span>
                        </span>
                      </div>
                    }
                  </td>
                  <td class="text-end">
                    {{ regionCurrencySymbol
                    }}{{ job?.sale_amount | number: "1.2-2" }}
                  </td>
                  <td class="text-end">
                    {{ regionCurrencySymbol
                    }}{{ job?.total_amount | number: "1.2-2" }}
                  </td>
                </tr>
              }
              @for (
                miscItem of additionalLineItems;
                track miscItem;
                let i = $index
              ) {
                <tr class="avoid-page-break">
                  <td class="text-center">
                    {{ i + 1 + selectedEvents?.length }}
                  </td>
                  <td>{{ miscItem?.itemName }}</td>
                  <td class="text-end">
                    {{ regionCurrencySymbol
                    }}{{ miscItem?.sale_amount | number: "1.2-2" }}
                  </td>
                  <td class="text-end">
                    {{ regionCurrencySymbol
                    }}{{ miscItem?.total_amount | number: "1.2-2" }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="d-none d-lg-block">
    <ng-template [ngTemplateOutlet]="invoiceOptionsTemplate"></ng-template>
  </div>
}

<div class="mt-1 mx-1">
  <div class="fixed-add-btn opacity-50 d-lg-none">
    <div class="d-flex align-items-center gap-2">
      <button
        class="btn btn-lg btn-secondary"
        title="Go Back"
        (click)="goBack(); $event.stopImmediatePropagation()"
      >
        <span> <i class="fa-solid fa-arrow-left"></i> </span>
      </button>
      <button
        class="btn btn-lg btn-success"
        (click)="openPrintDialog(); $event.stopImmediatePropagation()"
        title="Print Invoice"
      >
        <span><i class="fa-solid fa-print"></i></span>
      </button>
    </div>
  </div>
</div>

<ng-template #updateABNTemplate let-updateABNTemplate="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      ABN
      <span class="float-end" (click)="updateABNTemplate.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <form [formGroup]="abnForm" gtappFormEnterAction>
        <div class="input-group">
          <div class="form-floating">
            <input
              class="form-control"
              formControlName="abn"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              placeholder="ABN"
              id="updateABNField"
              minlength="11"
              maxlength="11"
              [class.is-invalid]="abnForm.controls['abn'].invalid"
            />
            <label>ABN</label>
          </div>
          @if (abnForm.value?.abn) {
            <span
              class="input-group-text"
              (click)="clearAndFocusTextBox('updateABNField')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </form>

      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="updateABNTemplate.close(false)"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="!abnForm.valid"
            (click)="updateABNTemplate.close(true)"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #invoiceOptionsTemplate
  ><div
    class="p-2 mb-2 d-flex doc-width gap-2 flex-wrap row-gap-4 row-gap-lg-2 justify-content-between"
  >
    <div class="d-none d-lg-block">
      <div class="d-flex align-items-center gap-2">
        <div
          class="border py-2 px-2 small px-lg-3 rounded my-auto bg-secondary text-white border-secondary text-center"
          role="button"
          title="Go Back"
          (click)="goBack()"
        >
          <span> <i class="fa-solid fa-arrow-left"></i> </span>
        </div>
        <!-- <div
                class="border py-2 px-2 px-lg-3 rounded text-white fs-5 bg-success"
                role="button"
                (click)="openPrintDialog()"
                title="Print Invoice"
                >
                <span><i class="fa-solid fa-print"></i></span>
              </div> -->
      </div>
    </div>

    <div
      class="border py-2 px-2 small px-lg-3 bg-white rounded my-auto text-success border-success text-center"
      role="button"
      (click)="sendMultipleDockets(reportConfirmationTemplate)"
    >
      Send Dockets
    </div>
    @if (companyDetails?.logo_url) {
      <div
        class="border py-2 px-2 small px-lg-4 bg-white rounded my-auto rounded text-center"
        [ngClass]="
          companyDetails?.hideLogo
            ? 'text-white bg-primary'
            : 'text-primary border-primary'
        "
        (click)="companyDetails.hideLogo = !companyDetails?.hideLogo"
        role="button"
      >
        {{ companyDetails?.hideLogo ? "Show Logo" : "Hide Logo" }}
      </div>
    } @else {
      <input
        #fileInput
        id="fileInput"
        style="display: none; cursor: pointer"
        type="file"
        accept="image/*"
        (change)="handleFileInput($event.target)"
      />

      <div
        (click)="openCamPopup()"
        class="border py-2 px-2 small px-lg-3 bg-white rounded my-auto text-primary border-primary text-center"
        role="button"
      >
        Upload Company Logo
      </div>
    }
    <div
      class="border py-2 px-2 small px-lg-3 bg-white rounded my-auto text-secondary border-secondary text-center"
      role="button"
      (click)="openTemplate(companyDialog)"
    >
      <!--https://app.shortcut.com/sendem/story/11272/enable-printing-invoices#activity-11342-->
      Edit Contact
    </div>
    @if (invoiceStatus == 0) {
      <div
        class="border py-2 px-2 small px-lg-3 bg-white rounded my-auto text-danger border-danger bg-white hover text-center"
        role="button"
        (click)="voidInvoice()"
      >
        <!--https://app.shortcut.com/sendem/story/11272/enable-printing-invoices#activity-11342-->
        Void Invoice
      </div>
    }
    <div
      class="border py-2 px-2 small px-lg-3 rounded my-auto text-white border-success bg-success text-center d-none d-lg-block"
      role="button"
      (click)="openPrintDialog()"
    >
      Print Invoice
    </div>
  </div></ng-template
>
<!-- send report confirmation  DIALOG -->
<ng-template
  #reportConfirmationTemplate
  let-reportConfirmationTemplate="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Select Recipients
      <span class="float-end" (click)="reportConfirmationTemplate.close(false)">
        <i class="fa-2x fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (reportRecipientList?.length) {
      <table class="table">
        <tbody>
          @for (contact of reportRecipientList; track contact; let i = $index) {
            <tr>
              <td class="border-0">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="!contact.isSnubbed"
                    (change)="selectUnselectRecipients(contact)"
                    id="check-{{ contact.id }}-{{ i }}"
                  />
                  <label
                    class="form-check-label"
                    for="check-{{ contact.id }}-{{ i }}"
                  >
                    {{ contact?.full_name }}
                    @if (contact?.is_site_contact) {
                      <span class="small-font text-secondary"
                        >[Site Contact]</span
                      >
                    }
                    <div class="small-font">
                      {{ contact?.email }}
                    </div>
                  </label>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="mb-2 alert alert-danger">
        There are no recipients configured for this site
      </div>
    }
    @if (selectedReportRecipientList?.length) {
      <dt class="text-end me-4">
        Total Recipients:
        <span class="fw-semibold fs-6">{{
          selectedReportRecipientList?.length
        }}</span>
      </dt>
    }

    <div class="row row-cols-2 pt-4">
      <div class="col">
        <button
          class="btn btn-lg btn-secondary w-100"
          type="button"
          (click)="reportConfirmationTemplate.close(false)"
        >
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          type="button"
          (click)="reportConfirmationTemplate.close(true)"
          [disabled]="!selectedReportRecipientList?.length"
        >
          Send Dockets
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #companyDialog let-cpRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Contact Details
      <span class="float-end" (click)="cpRef.close('close')">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <form [formGroup]="companyForm" gtappFormEnterAction>
      <div class="d-flex flex-column gap-2">
        @if (companyDialogueStep === 1) {
          @if (companyDetails?.name) {
            <div class="form-floating d-none">
              <input
                class="form-control"
                type="text"
                formControlName="name"
                placeholder="Company Name"
                [class.is-invalid]="
                  companyForm.controls['name'].invalid &&
                  companyForm.controls['name'].touched
                "
              />
              <label for="name">Company Name</label>
            </div>
          }
          <div class="form-floating d-none">
            <input
              class="form-control"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              formControlName="abn"
              placeholder="ABN"
              minlength="11"
              maxlength="11"
              [class.is-invalid]="companyForm.controls['abn'].invalid"
            />
            <label for="name">ABN</label>
          </div>
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              formControlName="email"
              placeholder="Email"
              placeholder="ABN"
              [class.is-invalid]="
                companyForm.controls['email'].invalid &&
                companyForm.controls['email'].touched
              "
            />
            <label for="email">Email</label>
          </div>
          <div class="form-floating">
            <input
              class="form-control"
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              minlength="7"
              maxlength="10"
              formControlName="phone"
              placeholder="Phone"
              [class.is-invalid]="
                companyForm.controls['phone'].invalid &&
                companyForm.controls['phone'].touched
              "
            />
            <label for="phone">Phone</label>
          </div>
          <div class="row row-cols-2">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-secondary w-100"
                (click)="companyDialogueStep = 1; cpRef.close('close')"
              >
                Cancel
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-primary w-100"
                id="submitbtn"
                [disabled]="!companyForm.valid"
                (click)="
                  updateCompanyData(); cpRef.close(); companyDialogueStep = 1
                "
              >
                Submit
              </button>
            </div>
          </div>
        }
      </div>
    </form>
  </div>
</ng-template>
